import { CommonHelper } from "../../shared/helpers/CommonHelper";

export class UtilsProjectCost {
    commonHelper: CommonHelper = new CommonHelper();

    multiSelectMonthsAndYears(date) {
        const currentYear = new Date().getFullYear();
        const months = this.commonHelper.multiSelectMonths();
        let  years = [currentYear];
        let monthYear = [];

        for (let i = 0; i < 3; i++) {
            years.push(years[i] + 1)
        };
        years.forEach(y => {
            months.forEach(m => {
                monthYear.push({
                    name: `${m.name}/${y}`,
                    _id: `${m._id}/${y}`
                });
            });
        });

        return monthYear.find(mY => date === mY._id);
    }

    multiSelectMonthsAndYearsInit() {
        const currentYear = new Date().getFullYear();
        const months = this.commonHelper.multiSelectMonths();
        let  years = [currentYear];
        let monthYear = [];

        for (let i = 0; i < 3; i++) {
            years.push(years[i] + 1)
        };
        years.forEach(y => {
            months.forEach(m => {
                monthYear.push({
                    name: `${m.name}/${y}`,
                    _id: `${m._id}/${y}`
                });
            });
        });
        return monthYear;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/project-cost/utils.ts